module.exports = "pegasus/assets/blue-ghost-linkedin.png";